<template>
    <DsSpinner v-if="loading" />

    <div v-else-if="isUnpaidInvoiceAutomationEnabled">
        <DsInline fill class="title">
            <small>{{ $t('funnel.edit.goal.integration.unpaid.invoice.title') }}</small>
            <DsButton @click="updateConfig">
                {{ $t('global.save') }}
            </DsButton>
        </DsInline>

        <DsStack class="field">
            <DsText variant="x-small">
                {{ 'Summary' }}
            </DsText>

            <DsText variant="mono">
                {{ $t('funnel.edit.goal.integration.unpaid.invoice') }}
            </DsText>


            <DsMultiselect
                :v-model="daysAfterDueDate"
                type="number"
                required
                placeholder="When the invoice was past due"
                show-blank
                :options="options"
            />

            <DsInputField
                v-if="showOtherOption"
                :v-model="daysAfterDueDate"
                type="number"
                placeholder="in X days"
                required
                :min="0"
                :max="90"
            />
        </DsStack>
    </div>
</template>

<script>
import {
    createOrUpdateUnpaidInvoiceConfig,
    getUnpaidInvoiceConfig,
} from './unpaid.invoice.api';

export default {
    components: {},
    props: {
        cell: {
            type: Object,
            required: true,
        },
        oracleId: {
            type: String,
            required: true,
        },

        flagsInfo: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['close-modal', 'update-config'],
    data() {
        return {
            daysAfterDueDate: 0,
            loading: true,
            options: [{
                id: '7',
                name: 'by 7 days',
                additional: 7,
            }, {
                id: '30',
                name: 'by 30 days',
                additional: 30,
            }, {
                id: '60',
                name: 'by 60 days',
                additional: 60,
            }, {
                id: '90',
                name: 'by 90 days',
                additional: 90,
            }, {
                id: 'other',
                name: 'Other',
            }],
        };
    },
    computed: {
        isUnpaidInvoiceAutomationEnabled() {
            return this.flagsInfo.unpaidInvoiceAutomationEnabled;
        },

        showOtherOption() {
            return this.daysAfterDueDate === 'Other';
        },
    },
    async mounted() {
        if (this.oracleId) {
            const { daysAfterDueDate } = await getUnpaidInvoiceConfig(this.oracleId);

            this.daysAfterDueDate = daysAfterDueDate;
        }

        this.loading = false;
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        async updateConfig() {
            await createOrUpdateUnpaidInvoiceConfig(this.oracleId, this.daysAfterDueDate);
            this.$emit('update-config');
        },
    },
};
</script>

<style lang="scss" scoped>
header {
    font-size: $font-size-xs;
    line-height: $line-height-sm;
}

.title {
    justify-content: space-between;
}

.field {
    margin-top: $spacing-100;
    display: flex;
    flex-direction: row;
}
</style>
